import { useMutation, useSuspenseQuery } from "@apollo/client";
import {
	GeneratePhoneActivationCodeDocument,
	GetWhatsAppPhoneNumberDocument,
} from "@src/gql/graphql";
import { useEffect } from "react";

export function useGenerateActivationLink() {
	const { data: businessAccountPhoneData } = useSuspenseQuery(
		GetWhatsAppPhoneNumberDocument,
	);

	const [getActivationCode, { data: activationCodeData, error }] = useMutation(
		GeneratePhoneActivationCodeDocument,
	);

	useEffect(() => {
		getActivationCode();
	}, [getActivationCode]);

	if (error) {
		throw error;
	}

	const phoneNumber =
		businessAccountPhoneData.integrations?.whatsAppPhoneNumber;
	const activationCode =
		activationCodeData?.user?.generatePhoneActivationCode?.phoneActivationCode;

	let activationLink: string | null = null;

	if (phoneNumber && activationCode) {
		activationLink = `https://wa.me/${phoneNumber}?text=%2Fstart%20${activationCode}`;
	}

	return { activationLink };
}
